import React from 'react';

function TextBreadcrumb({ parentTitle = '', subTitle = '', companySlug = '' }) {
  const parentHref = companySlug ? `/${companySlug}/paths` : undefined;
  return (
    <div className="item-path-authoring-toolbar un-pe-bcwrap">
      <div className="breadcrum-path-authoring un-pe-bc">
        <a className="link-breadcrum-path-authoring un-pe-bc__parent" href={parentHref}>{parentTitle}</a>
        <span className="un-pe-bc__sep">/</span>
        <div className="text-breadcrum-path-authoring un-pe-bc__title">{subTitle}</div>
      </div>
    </div>
  );
}

export default TextBreadcrumb;
